// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__3zVgJ","aboutText":"About_aboutText__2mTAA","title":"About_title__3P7iF"};